import React from 'react';
import styled from 'styled-components';

import { Add, NavigateBefore } from '@material-ui/icons';
import { IconButton, Typography, Paper } from '@material-ui/core';

export const Container = styled(Paper)`
  background-color: white;
  max-width: 340px;
  position: absolute;
  top: 99%;
  width: 100%;
  right: 0;
  height: 400px;
  display: ${({ loading }) => (loading ? 'flex' : 'block')};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 20px;
`;

const AddIcon = styled(Add)``;

export const AddButton = styled(IconButton).attrs(() => ({
  children: <AddIcon color="primary" />,
}))`
  margin-left: auto;
  padding: 0px;
`;

export const GoBack = styled(IconButton).attrs(() => ({
  children: <NavigateBefore color="primary" />,
}))`
  margin-left: -8px;
  padding: 0px;
  position: absolute;
`;

export const NoNotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 20px;
`;

export const NoItemsImage = styled.img`
  margin: auto;
`;

export const NoItemsText = styled(Typography)`
  color: black;
  text-align: center;
  font-weight: bold;
  margin-top: 40px;
`;

export const NoItemsHelperText = styled(Typography)`
  color: black;
  text-align: center;
  font-size: 0.9rem
  margin-top: 10px;
`;

export const NotificationDetailText = styled(Typography)`
  color: black;
  margin: auto;
`;

export const DetailCategory = styled(Typography)`
  text-align: left;
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.9rem;
  margin: 10px 0px 0px 0px;
`;

export const Names = styled(Typography)`
  color: black;
  font-size: 0.9rem;
  max-height: 96px;
  overflow: auto;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 20px 30px 20px;
`;
